import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/verify-email-address-change")({
  component: VerifyEmailChange,
});

function VerifyEmailChange() {
  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl text-gray-900">Email address updated</h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Your new email address is now active.{" "}
          <Link to="/account" className="font-medium text-primary-600 hover:text-primary-500">
            Back to your account
          </Link>
        </p>
      </div>
    </div>
  );
}
